import { Component, ViewChild, OnInit, OnDestroy, AfterContentChecked, ViewChildren, QueryList } from '@angular/core';
import { MatDialog } from "@angular/material";
import { isValidNumber } from 'libphonenumber-js';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { Subject, Subscription, EMPTY } from 'rxjs';

import { phoneFormatInputPipe } from '../pipes/phone-formatter-input.pipe';
import { config } from './../../../config/index';

import { SuperAdminListService } from "./super-admin-listing.service"
import { SnackbarService } from "../shared/services/snackbar.service";
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";

import { PaginationComponent } from '../shared/components/pagination/pagination.component';
@Component({
    template: require('./super-admin-listing.component.html'),
    styles: [require('./super-admin-listing.component.less')],
    providers: [SuperAdminListService, MatDialog, SnackbarService, phoneFormatInputPipe, TooltipService],
    preserveWhitespaces: true
})
export class superAdminListingComponent implements OnInit, OnDestroy, AfterContentChecked {

    superAdminListData: any = [];
    itemsPerPage: number = 10;
    page: number = 0;
    sortParam: string;
    order: string;
    superAdminTotalCount: number;
    startCount: number;
    endCount: number;
    searchKey: any;
    master: any;
    paginationItems: any = [];
    selectedType: any;
    sortParamsConfig: any = [];
    sortParams: any = ['id', 'first_name', 'username'];
    loading: boolean = false;
    deleteUserRoleLocations: any = [];
    deleteUserReassignList: any = [];
    deleteUserReassignValue: any = [];
    deleteUserReassignError: boolean = false;
    deleteSuperAdminId: any;
    currentUserRole: any;
    deleteUserLoading: boolean = false;
    isTouchDevice: boolean;
    dialogNewClasses: string;
    _superAdminData: any;
    fullName: string;
    practiceArray: any = []
    selectPracticeData: any = [];
    captcha_required: boolean = false;
    practiceDropdownList: any = [];
    dropdownSettings = {};
    focused: boolean = false;
    viewAllPractices: boolean = false;
    allPractices: any = [];
    addOrEdit: any = '';
    countryList: any = [];
    stateList: any = [];
    postCodeRanges: any = [];
    timeZoneList: any = [];
    countryCodes: any;
    countryCode: any;
    selectedCountry: any;
    requiredData: boolean = false;
    validationClassForState: string = 'selector';
    validationClassForCountry: string = 'selector';
	validationClassForTimezone: string = 'selector';
    userData: any = { address: {}, practice_ids: [] };
    contactError: boolean = false;
    emailError: boolean = false;
    zipFormat: any = /\b\d{5}\b/;
    postalFormat: any = /^([a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d)$/;
    zipError: boolean;
    zipCodeError: boolean = false;
    captcha: string;
    reqItemsPerPage: number;
    reqPageOffset: number = 0;
    searchValue: string = '';
    isSubmitted: boolean = false;
    phoneNumRegex: any =  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    stateProvinceLabel = 'STATE';
    emailExistsError: boolean;
    emailRegexPattern: any = config.emailRegexPattern;
    emailRegex: any = config.emailRegex;

    limitInputSub$: Subject<string> = new Subject<string>();
    searchInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    searchInputSubscription: Subscription;
    listSuperAdminApiSubscription: Subscription;
    deleteSuperAdminApiSubscription: Subscription;
    addOrEditSuperAdminApiSubscription: Subscription;
    getIndividualSuperAdminApiSubscription: Subscription;
    apiSubscription: Subscription[] = [];

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild('addSuperAdmin', { static: false }) addSuperAdmin: any;
    @ViewChild('deleteSuperAdminPopup', { static: false }) deleteSuperAdminPopup: any;
    @ViewChildren(AngularMultiSelect) multiselectDropdowns : QueryList<AngularMultiSelect>;

    constructor(
        private _superAdminListService: SuperAdminListService,
        public dialog: MatDialog,
        public _mdlSnackbarService: SnackbarService,
        private _phonepipe: phoneFormatInputPipe,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _tooltipService: TooltipService
    ) {
    }

    /**
     * Function invoked for accessing Users List
     */
    superAdminList = (itemsPerPage: any, page: any, searchKey: any) => {
        this.loading = true;
        this.itemsPerPage = itemsPerPage;
        this.page = page;
        this.listSuperAdminApiSubscription?.unsubscribe();
        this.listSuperAdminApiSubscription = this._superAdminListService.superAdminListService(itemsPerPage, page, searchKey, this.sortParam, this.order)
            .subscribe((res: any) => this.superAdminListSuccessHandler(res),
                (error: any) => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    /**
    * Function for Users List Success CallBack
    * @param  {any} response contains response from success CallBack
    */
    superAdminListSuccessHandler = (response: any) => {
        if (!response.data) {
            this.superAdminListData = [];
        } else {
            this.superAdminListData = response.data;
            this.superAdminListData.map((listData: any) => {
                listData.viewPractices = false;
            });
        }

        this.superAdminTotalCount = response.count;
        if (this.superAdminListData.length !== 0) {
            this.startCount = this.page + 1;
            this.endCount = this.startCount + this.superAdminListData.length - 1;
        } else {
            this.startCount = 0;
            this.endCount = 0;
        }
        this.loading = false;
    }

    viewAllPracticeData(id: any) {
        this.loading = true;
        this.superAdminListData.forEach((listData: any) => {
            if (listData.id === id) {
                listData.viewPractices = !listData.viewPractices;
                if (listData.viewPractices) {
                    this.allPractices = listData.practices;
                }
            }
            else {
                listData.viewPractices = false;
            }
            this.loading = false;
        });
    }

    /**
     * Function to set items Per page value
     * @param  {any} limitValue
     * @param  {any} event
     */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.itemsPerPage = this.paginationItems.passedItems;
            this.page = this.paginationItems.reqOffset;
            this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.superAdminTotalCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        if (event.isClicked) {
            this.superAdminList(event.itemsPerPage, event.offset, this.searchKey);
        }
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
    }

    deleteSuperAdmin(superAdmin: any) {
        this.deleteSuperAdminId = superAdmin.id;
        this.captcha = '';
        this.captcha_required = false;
        this.deleteSuperAdminPopup.show();

    }

    startObserverForMdlSelectDropdowns() {
        setTimeout(() => {
            let mdlSelectDropdowns: any = document.querySelectorAll('.mdl-popover');
            // observer for checking mdl-select class change
            let observer = new MutationObserver((event) => {
                this.closeMultiselectDropdown();
              })
            mdlSelectDropdowns.forEach((dropdown: any) => {
                observer.observe(dropdown, {
                  attributes: true,
                  attributeFilter: ['class'],
                  childList: false,
                  characterData: false
                })
            });
        }, 1000);
    }

    openaddSuperAdmin(): void {
        this.addOrEdit = '';
        this.emailExistsError = false;
        this.addSuperAdmin.show();
        this.startObserverForMdlSelectDropdowns();
    }

    /**
     * Function to open edit super admin popup
     * @param  {any} id
     */

    editSuperAdminPopup(id: any) {
        this.requiredData = false;
        this.getIndividualSuperAdminApiSubscription?.unsubscribe();
        this.getIndividualSuperAdminApiSubscription = this._superAdminListService.getSuperAdminDetails(id)
            .subscribe((res: any) => {
                this.userData = res.data;
                this.countryList.forEach((country: any) => {
                    if (country.id === this.userData.address.country_id) {
                        this.stateList = country.states;
                        this.selectedCountry = country;
                        this.setStateLabel();
                        this.stateSelected(true);
                        this.countryCode = this.selectedCountry.code;
                    }
                });
                this.userData.practice_ids = [];
                if (this.userData.practices) {
                    this.userData.practices.forEach((item: any) => {
                        item['itemName'] = item.name;
                    });
                    this.practiceArray = this.userData.practices;
                    this.practiceArray.forEach((item: any) => {
                        this.userData.practice_ids.push(item.id);
                    });
                }
            },
                (error: any) => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
        this.addSuperAdmin.show();
        this.startObserverForMdlSelectDropdowns();
        this.addOrEdit = 'EDIT_USER';
    }

    closeDialog() {
        this.userData = { address: {}, practice_ids: [] };
        this.selectedCountry = null;
        this.countryCode = null;
        this.practiceArray = [];
        this.requiredData = false;
        this.validationClassForCountry = 'selector';
        this.validationClassForState = 'selector';
        this.validationClassForTimezone = 'selector';
        this.emailError = false;
        this.contactError = false;
        this.isSubmitted = false;
        this.zipError = false;
        this.deleteUserReassignError = false;
        this.addSuperAdmin.close();
    }

    closeDeleteUserPopUp(): void {
        this.deleteSuperAdminPopup.close();
    }

    ngOnDestroy() {
        this.addSuperAdmin.close();
        this.deleteSuperAdminPopup.close();

        this.apiSubscription.forEach((subscription: any) => {
            subscription?.unsubscribe();
        });
        this.inputSubscription?.unsubscribe();
        this.searchInputSubscription?.unsubscribe();
        this.listSuperAdminApiSubscription?.unsubscribe();
        this.deleteSuperAdminApiSubscription?.unsubscribe();
        this.addOrEditSuperAdminApiSubscription?.unsubscribe();
        this.getIndividualSuperAdminApiSubscription?.unsubscribe();
    }

    deleteSuperAdminComfirm() {
        this.captcha_required = true;
        if (this.captcha === 'DELETE') {
            this.deleteUserLoading = true;
            this.deleteSuperAdminApiSubscription?.unsubscribe();
            this.deleteSuperAdminApiSubscription = this._superAdminListService.deleteSuperAdmin(this.deleteSuperAdminId)
                .subscribe((res: any) => {
                    this.deleteUserLoading = false;
                    this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
                    this._mdlSnackbarService.showSnackbar('DELETED', 'success');
                }, (error: any) => {
                    this.deleteUserLoading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                })
            this.deleteSuperAdminPopup.close();
        } else {
            this._mdlSnackbarService.showSnackbar('WRONG_CAPTCHA', 'error');
        }
    }

    addBlueBorder(event: any) {
        if (event === 'focused') {
            this.focused = true;
        } else {
            this.focused = false;
        }
    }

    /**
     * Function to Validate super admin data
     */

    validation(data: any) {
        let EMAIL_REGEXP = new RegExp(this.emailRegex);
        if (this.selectedCountry) {
            this.checkZipCodeValidity(data);
            if (this.zipError) {
                return false;
            }
        }
        this.validateContactNumber();
        if (this.contactError) {
            return false;
        }
        if (!EMAIL_REGEXP.test(data.email)) {
            this.emailError = true;
            return false;
        }
        if (this.addOrEdit !== 'EDIT_USER' && data.first_name && data.last_name && data.username
            && data.temporary_password && data.address.street_address1 && data.address.country_id && data.address.state_id && data.address.zip && data.address.time_zone
            && data.contact_number && data.email && data.practice_ids) {
            return true;
        } else if (this.addOrEdit === 'EDIT_USER' && data.first_name &&  data.last_name && data.username
            && data.address.street_address1 && data.address.country_id && data.address.state_id && data.address.zip && data.address.time_zone
            && data.contact_number && data.email && data.practice_ids) {
            return true;
        } else {
            this.validationErrorCases(data);
        }
    }

    validationErrorCases(data: any) {
        if (!data.address.country_id) {
            this.validationClassForCountry = 'selector val-error';
        }
        if (!data.address.state_id) {
            this.validationClassForState = 'selector val-error';
        }
        if (!data.address.time_zone) {
            this.validationClassForTimezone = 'selector val-error';
        }
        if (!data.address.zip) {
            this.zipError = true;
        }
        if (!data.contact_number) {
            this.contactError = true;
        }
        if (!data.email) {
            this.emailError = true;
        }

        this.requiredData = true;

        return false;
    }

    checkZipCodeValidity(data: any) {
        if (this.selectedCountry.name === 'USA') {
            this.zipError = !this.zipFormat.test(data.address.zip);
        } else if (this.selectedCountry.name === 'Canada') {
            this.zipError = !this.postalFormat.test(data.address.zip);
        } else {
            if (!data.address.zip) {
                this.zipError = true;
            }
        }
    }

    /**
     * Function to fetch practices data
    */

    getPractices = () => {
        this.apiSubscription.push(this._superAdminListService.getPractices()
            .subscribe((res: any) => {
                this.practiceDropdownList = res.data;
                this.practiceDropdownList.forEach((item: any) => {
                    item['itemName'] = item.name;
                });
            },
                (error: any) => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
    }

    /**
     * Function to remove practices from multi select data
    */

    removePractice(event: any) {
        let spliceIndex = this.practiceArray.map(function (value: any) { return value.id; }).indexOf(event.id)
        this.userData.practice_ids.splice(spliceIndex, 1);
    }

    /**
     * Function to select practices to multi select data
    */

    selectedPractice(event: any) {
        this.practiceDropdownList.forEach((item: any) => {
            if (event.id === item.id) {
                this.userData.practice_ids.push(item.id);
            }
        });
    }

    /**
     * Function to open multi select dropdown
    */

    multiSelectOpen() {
        let element: HTMLElement = document.getElementsByClassName('c-btn')[0] as HTMLElement;
        let dropdownElement: HTMLElement = document.getElementsByClassName('c-angle-down')[0] as HTMLElement;
        if (dropdownElement) {
            if (!(dropdownElement.classList.contains('c-angle-up'))) {
                setTimeout(() => {
                    element.click();
                }, 0);
            }
        }
    }

    getCities = () => {
        this.apiSubscription.push(this._superAdminListService.getCities()
            .subscribe((res: any) => {
                this.getCitiesSuccessHandler(res.data);
            },
                (error: any) => {
                    this.loading = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                }));
    }

    getCitiesSuccessHandler(continents: any) {
        continents.forEach((continent: any) => {
            continent.countries.forEach((country: any) => {
                this.countryList.push(country);
            });
        });
        if (this.addOrEdit === 'EDIT_USER') {
            this.countryList.forEach((country: any) => {
                if (country.id === this.userData.address.country_id) {
                    this.stateList = country.states;
                    this.selectedCountry = country;
                    this.setStateLabel();
                    this.stateSelected(true);
                    this.countryCode = this.selectedCountry.code;
                }
            });
        }
    }

    /**
     * Function to ADD/EDIT Super admin 
     * @param  {any} userData
    */

    addEditSuperAdmin(userData: any) {
        this.isSubmitted = true;
        setTimeout(() => {            
            if (this.validation(this.userData) && !document.querySelector('.val-error')) {
                // convert phone format before saving
                if (this.userData.contact_number && (this.countryCode === 'US' || this.countryCode === 'CA')) {
                    this.userData.contact_number = this._phonepipe.transform(this.userData.contact_number, this.countryCode, true);
                }
                this.loading = true;
                this.addOrEditSuperAdminApiSubscription?.unsubscribe();
                if (this.addOrEdit === 'EDIT_USER') {
                    this.addOrEditSuperAdminApiSubscription = this._superAdminListService.editUser(userData).
                        subscribe((res: any) => this.editUserSuccessHandler(res),
                            (error: any) => this.editUserError(error));
                } else {
                    this.addOrEditSuperAdminApiSubscription = this._superAdminListService.addUser(this.userData).
                        subscribe((res: any) => this.addUserSuccessHandler(res),
                            (error: any) => this.addUserError(error));
                }
            } else {
                if (this.zipError) {
                    this._mdlSnackbarService.showSnackbar('ZIP_CODE_ERROR', 'error');
                } else if (this.contactError) {
                    this._mdlSnackbarService.showSnackbar('INVALID_NUMBER', 'error');
                } else if (this.emailError) {
                    this._mdlSnackbarService.showSnackbar("PROVIDE_VALID_EMAIL", 'error');
                } else {
                    this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
                }
            }
        });
    }

    addUserSuccessHandler(res: any) {
        this.loading = false;
        if (res.status == "ok") {
            this._mdlSnackbarService.showSnackbar('USER_CREATE_SUCCESS', 'success');
            this.closeDialog();
            this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
        } else if (res.error_code === 100) {
            if (res.message === 'EMAIL_USER_EXISTS') {
                this.emailExistsError = true;
            }
            this._mdlSnackbarService.showSnackbar(res.message, 'error');
        } else if (res.error_code === 103) {
            this._mdlSnackbarService.showSnackbar('PASSWORD_LENGTH_ERROR', 'error');
        }
    }

    addUserError(error: any) {
        this.loading = false;
        if (error.error_code === 100) {
            this._mdlSnackbarService.showSnackbar('USERNAME_ALREADY_EXIST', 'error');
        } else {
            this._mdlSnackbarService.showSnackbar('USER_NOT_CREATED', 'error');
        }
    }

    editUserSuccessHandler(res: any) {
        this.loading = false;
        if (res.status == "ok") {
            this._mdlSnackbarService.showSnackbar('USER_UPDATE_SUCCESS', 'success');
            this.closeDialog();
            this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
        } else if (res.error_code === 100) {
            if (res.message === 'EMAIL_USER_EXISTS') {
                this.emailExistsError = true;
            }
            this._mdlSnackbarService.showSnackbar(res.message, 'error');
        }
    }

    editUserError(error: any) {
        this.loading = false;
        this._mdlSnackbarService.showSnackbar('USER_NOT_UPDATED', 'error');
    }

    countrySelected() {
        this.userData.address.country_id = this.selectedCountry.id;
        this.countryCode = this.selectedCountry.code;
        this.userData.contact_number = '';
        this.userData.address.time_zone = null;
        this.userData.address.zip = '';
        this.validateContactNumber();
        this.stateList = null;
        this.timeZoneList = null;
        this.postCodeRanges = [];
        this.userData.address.state_id = null;
        this.validationClassForCountry = 'selector';
        this.setStateLabel();
        this.countryList.forEach((country: any) => {
            if (country.id === this.userData.address.country_id) {
                this.stateList = country.states;
            }
        })
    }

    stateSelected(isOnLoad?: boolean) {
        this.validationClassForState = 'selector';
        if (!isOnLoad) {
            this.userData.address.time_zone = null;
            if (this.selectedCountry.name.toLowerCase() === 'australia') {
                this.userData.address.zip = null;
            }
        }

        this.stateList.forEach((state: any) => {
            if (state.id === this.userData.address.state_id) {
                this.timeZoneList = state.timezones;
                this.postCodeRanges = state.zip_code_ranges;
                setTimeout(() => {
                    if (this.userData.address.time_zone && !this.timeZoneList.includes(this.userData.address.time_zone)) {
                        this.userData.address.time_zone = '';
                    }
                });
            }
        });
    }

    validateContactNumber(event?: any) {
        this.contactError = false;
        if (event) {
            this.userData.contact_number = event;
            let pipeValue = this._phonepipe.transform(event.target.value, this.countryCode);
            this.userData.contact_number = event.target.value = pipeValue;
        } else {
            if (this.userData.contact_number && (this.countryCode === 'US' || this.countryCode === 'CA')) {
                this.userData.contact_number = this._phonepipe.transform(this.userData.contact_number, this.countryCode);
            }
        }
        if (this.userData.contact_number && this.countryCode) {
            if (this.countryCode === 'US' || this.countryCode === 'CA') {
                this.contactError = !this.phoneNumRegex.test(this.userData.contact_number) && !isValidNumber(this.userData.contact_number, this.countryCode);
            } else {
                this.contactError = !isValidNumber(this.userData.contact_number, this.countryCode);
            }
        }
    }

    zipFormatter(isZip?: boolean) {
        if (!isZip) {
            let cleaned = ('' + this.userData.address.zip).replace(/\s/g, ''),
                formattedVal = cleaned;

            const zip = cleaned.substring(0, 3);
            const last = cleaned.substring(3, 6);

            if (cleaned.length > 3) {
                formattedVal = `${zip} ${last}`;
            } else if (cleaned.length > 0) {
                formattedVal = `${zip}`;
            }
            this.zipError = !this.postalFormat.test(formattedVal);

            setTimeout(() => {
                this.userData.address.zip = formattedVal;
            });
        } else {
            let cleaned = ('' + this.userData.address.zip).replace(/\D/g, '').slice(0, 5);
            this.zipError = !this.zipFormat.test(cleaned);

            setTimeout(() => {
                this.userData.address.zip = cleaned;
            });
        }
    }

    searchItem() {
        this.loading = true;
        this.reqPageOffset = 0;
        this.superAdminList(this.itemsPerPage, this.page, this.searchKey);
    }

    closeMultiselectDropdown() {
        this.multiselectDropdowns.forEach((dropdown: any) => {
            if (dropdown.isActive) {
                dropdown.closeDropdown();
            }
        })
    }

    /** To set state label based on selected country */
     setStateLabel() {
        switch (this.selectedCountry.name.toLowerCase()) {
            case 'usa':
                this.stateProvinceLabel = 'STATE';
                break;
            case 'canada':
                this.stateProvinceLabel = 'PROVINCE';
                break;
            case 'australia':
                this.stateProvinceLabel = 'STATE_TERRITORY';
                break;
            default:
                this.stateProvinceLabel = 'STATE_PROVINCE';
                break;
        }
    }


    ngOnInit() {
        this.dropdownSettings = {
            singleSelection: false,
            text: "",
            enableSearchFilter: true,
            enableCheckAll: false,
            classes: "multi-select-dropdown multiselect-dropdown-additional"
        };
        this.superAdminList(10, 0, this.searchKey);
        this.selectedType = 10;
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
        this.selectedType = 10;
        this.getCities();
        this.practiceDropdownList = [];
        this.getPractices();

        // add delay for setting pagination limit on typing
        this.inputSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();

        // add delay for searching on typing
        this.searchInputSubscription = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(() => {
                this.searchItem();
                return EMPTY;
            })
        ).subscribe();
    }

    ngAfterContentChecked() {
        this.isTouchDevice = "ontouchstart" in document.documentElement;
        if (this.isTouchDevice) {
            this.dialogNewClasses = "new-dialog-container super-admin-popup";
        } else {
            this.dialogNewClasses = "new-dialog-container super-admin-popup desktop-view";
        }
    }
}